<template>
  <div class="robbing">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" @click="toggleType('ing')">进行中</div>
      <div class="robbing-nav-item" @click="gotoOtherStatus('complete')">已完成</div>
      <div class="robbing-nav-item" @click="gotoOtherStatus('cancel')">已取消</div>
      <div class="robbing-nav-item select">今日数据</div>
    </nav>

    <div class="empty-data" @click="export2Excel">
      <div>
        <i class="iconfont icon-xiangqing"></i>
      </div>
      <div>
        <p>下载数据</p>
      </div>
    </div>

    <div class="weui-footer">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import Blob from "../../excel/Blob";
import Export2Excel from "../../excel/Export2Excel.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      year: moment().format("YYYY"),
      tableData: []
    };
  },
  created() {
    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    axios
      .get("/api/paotuiOrder/getListForDownload")
      .then(res => {
        loading.hide(function() {});
        if (res.data.success) {
          this.tableData = res.data.data;
        }
      })
      .catch(err => {
        this.haveData = false;
        loading.hide(function() {});
        weui.alert("导出跑腿单失败");
      });
  },
  methods: {
    toggleType(status) {
      this.$router.push("/robbingList/2/" + status + "/" + this.encodeToken);
    },
    gotoOtherStatus(status) {
      this.$router.push(
        "/robbingListCompleteOrCancel/2/" + status + "/" + this.encodeToken
      );
    },
    export2Excel() {
      if (this.tableData.length > 0) {
        require.ensure([], () => {
          const { export_json_to_excel } = require("../../excel/Export2Excel");
          const tHeader = [
            "代拿单号",
            "快递公司",
            "取件码",
            "跑腿姓名",
            "联系电话",
            "应付金额",
            "实付金额",
            "支付状况",
            "楼栋名称",
            "楼栋楼层",
            "宿舍房号",
            "收件人姓名",
            "收件人电话"
          ];
          // 上面设置Excel的表格第一行的标题
          const filterVal = [
            "no",
            "expressCompanyName",
            "storageInfo",
            "name",
            "phone",
            "fee",
            "payFee",
            "isPayed",
            "buildingName",
            "dormFloor",
            "dormRoom",
            "initiator",
            "initiatorPhone"
          ];
          // 上面的index、nickName、name是tableData里对象的属性
          const list = this.tableData; //把data里的tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(
            tHeader,
            data,
            "今日跑腿数据-" + moment().format("YYYY年MM月DD日 HH点mm分导出")
          );
        });
      } else {
        weui.alert("暂无数据");
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>

<style scoped>
.robbing {
  font-size: 14px;
}
.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
}
.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.robbing-nav-item:last-child {
  border-right: none;
}
.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}
.item {
  text-align: center;
  border: 1px solid #1aad19;
  margin: 15px;
}
.item + .item {
  margin-top: 10px;
}
.express-company {
  margin-top: 15px;
  font-size: 22px;
  font-weight: bold;
}
.express-count {
  color: orangered;
  font-weight: bold;
}
.img-container {
  margin-top: 10px;
  margin-bottom: 15px;
}
.img {
  width: 200px;
  height: 200px;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.empty-data {
  text-align: center;
  margin-top: 50px;
}
.empty-data div i {
  font-size: 120px;
  color: orangered;
}
.empty-data div p {
  font-size: 30px;
  color: orangered;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/PaotuiQrcode.vue